export const FEATURE_IDS = {
  SEARCH_PAGE_DISPLAY: 'SEARCH_PAGE_DISPLAY',
  ANALYTICS: 'ANALYTICS',
  INTEGRATION: 'INTEGRATION',
  SWATCH_SETTINGS: 'SWATCH_SETTINGS',
  SORT_BY_OPTIONS: 'SORT_BY_OPTIONS'
};